import React from "react"
import ReactDOM from "react-dom/client"
import './index.css';

import { Header } from './ui/Header/Header';

import { Provider } from "react-redux"
import { persistor, store } from "./slices/store";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { CreateRoom } from "./pages/CreateRoom/CreateRoom";
import { MusicMafia } from "./pages/MusicMafia/MusicMafia";
import { PersistGate } from "redux-persist/integration/react";

import i18n from './translations/i18n';
import { I18nextProvider } from "react-i18next";
import { CloseWSError } from "./pages/CloseWSError/CloseWSError";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <CreateRoom />,
  },
  {
    path: "/:roomId",
    element: <MusicMafia />,
  },
  {
    path: "/close-ws",
    element: <CloseWSError />
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Header />
        <div className="main-section">
          <RouterProvider router={router} />
        </div>
      </PersistGate>
    </Provider>
  </I18nextProvider>
    // <AppDima />
);
